export default __webpack_public_path__ + "static/media/app_icon.b9490323.png";